import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, PHONE } from "../lib/api";
import { useSEO } from "../lib/useSEO";
import { Reveal } from "../components/Reveal";
import { Breadcrumbs, CtaBand } from "../components/Shared";
import { PhoneBox } from "../components/Layout";
import { MapPin } from "lucide-react";

export default function CitiesIndex() {
  const [cities, setCities] = useState([]);
  useSEO({ title: "Serrurier par ville en Seine-et-Marne (77) | Toutes nos zones d'intervention", description: `Trouvez un serrurier près de chez vous en Seine-et-Marne : Melun, Meaux, Chelles, Fontainebleau et toutes les communes du 77. Dépannage 7j/7 ☎ ${PHONE}.`, path: "/villes" });
  useEffect(() => { api.get("/cities").then(r => setCities(r.data)).catch(() => {}); }, []);

  return (
    <div className="bg-white">
      <section className="relative pt-32 pb-16 sm:pt-36 hero-grid">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <Breadcrumbs items={[{ label: "Accueil", to: "/" }, { label: "Zones d'intervention" }]} />
          <Reveal>
            <p className="overline mb-4">{cities.length} communes couvertes</p>
            <h1 className="text-4xl sm:text-6xl font-display font-semibold tracking-tighter leading-[0.95] max-w-4xl text-zinc-900">Serrurier dans toute la Seine-et-Marne</h1>
            <p className="text-lg text-zinc-600 mt-8 max-w-2xl leading-relaxed">Sélectionnez votre ville pour découvrir nos interventions locales, nos délais et les questions fréquentes propres à votre commune.</p>
            <div className="mt-8"><PhoneBox /></div>
          </Reveal>
        </div>
      </section>
      <section className="relative z-10 py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cities.map((c, i) => (
            <Reveal key={c.slug} delay={(i % 3) * 0.04}>
              <Link to={`/serrurier/${c.slug}`} data-testid={`city-link-${c.slug}`} className="group card-soft flex items-center justify-between rounded-2xl border border-zinc-200 bg-white p-5 shadow-sm">
                <div className="flex items-center gap-3">
                  <div className="grid place-items-center h-10 w-10 rounded-xl bg-primary/10 shrink-0"><MapPin className="h-5 w-5 text-primary" /></div>
                  <div><div className="font-medium text-zinc-900 group-hover:text-primary transition-colors">Serrurier {c.name}</div><div className="text-xs text-zinc-500">{c.cp} · {c.secteur}</div></div>
                </div>
                <span className="text-zinc-300 group-hover:text-primary transition-colors">→</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CtaBand />
    </div>
  );
}
